import { useSelector } from "react-redux";
import logoSVG from "../../assets/images/logo/logosvg.svg";

export function PrimaryLogo(props) {
    const globalTheme = useSelector(state => state.Theme);
    const logo = globalTheme?.logo || logoSVG;


    return (
        <img src={logo} alt="Logo" className="h-10"
            style={{
                maxHeight: '120px',
                maxWidth: '180px'
            }}
            {...props}  // Spread props to allow passing additional attributes
        />
    );
}